module.exports = __webpack_public_path__ + "media/categories/88-5c15d7da.png";